import React from "react";
import BarekamText from "../../../../../../components/text";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";
import {MenuItem} from "@mui/material";
import {useAppSelector} from "../../../../../../../redux/store";
import {collectionNames} from "../../../../../../../constants";
import {getMessage} from "../../../../../../shared/helper-functions";

const CollectionFilter = (props: CollectionFilterProps) => {
    const {selectedCollection, onFilterChange} = props;
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    return (
        <>
            <BarekamSelect
                variant={'outlined'}
                label={<Message messageKey={'collection'} sectionId={MessageSections.ORDERS}/>}
                value={selectedCollection || 'all'}
                type={"filter"}
                fullWidth
                required>
                <MenuItem onClick={() => onFilterChange(undefined)}
                                value={'all'}
                                key={'all'}>
                    <BarekamText variant={"m"}>
                        <Message messageKey={"all"} sectionId={MessageSections.ORDERS}/>
                    </BarekamText>
                </MenuItem>
                {
                    collectionNames.map(collection =>
                        <MenuItem onClick={() => onFilterChange(collection)}
                                        value={collection}
                                        key={collection}>
                            <BarekamText variant={"m"}>
                                {getMessage(collection, MessageSections.MAIN, messageCache, languageId)}
                            </BarekamText>
                        </MenuItem>
                    )
                }
            </BarekamSelect>
        </>
    );
};

export default CollectionFilter;


interface CollectionFilterProps {
    selectedCollection: string | undefined;
    onFilterChange: (filter: string | undefined) => void
}